import React from "react";
import {AuthorDetails, AuthorDetailsIcon, ContactDetailLink} from "./AuthorDetails";
import mailImage from "../../../../images/icon-mail@2x.png";

export const AuthorEmail = ({authorDetails}) => {
    const {email, active} = authorDetails;
    if (!active || !email) return null;

    return <AuthorDetails>
        <AuthorDetailsIcon src={mailImage}/>
        <ContactDetailLink href={"mailto:" + email} className="t-email">{email}</ContactDetailLink>
    </AuthorDetails>;
};